import { render, staticRenderFns } from "./DetailsSection.vue?vue&type=template&id=2edda5fc&scoped=true"
import script from "./DetailsSection.vue?vue&type=script&lang=js"
export * from "./DetailsSection.vue?vue&type=script&lang=js"
import style0 from "./DetailsSection.vue?vue&type=style&index=0&id=2edda5fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edda5fc",
  null
  
)

export default component.exports